if (!customElements.get('akr-gallery-nav')) {
  customElements.define(
    'akr-gallery-nav',
    class AkrGalleryNav extends HTMLElement {
      connectedCallback() {
        this.thumbnails = this.closest('media-gallery')?.querySelector('[id^="GalleryThumbnails"]');
        if (!this.thumbnails) {
          this.hidden = true;
          return;
        }

        this.navButtons = Array.from(this.querySelectorAll('.akr-gallery-nav__button'));
        this.onClick = (event) => this.step(Number(event.currentTarget.dataset.direction));
        this.navButtons.forEach((button) => button.addEventListener('click', this.onClick));

        this.observer = new MutationObserver(() => this.update());
        this.observer.observe(this.thumbnails, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.navButtons?.forEach((button) => button.removeEventListener('click', this.onClick));
      }

      visibleThumbnails() {
        return Array.from(this.thumbnails.querySelectorAll('[data-target] button')).filter(
          (button) => button.closest('[data-target]').offsetParent !== null
        );
      }

      currentIndex(thumbnails) {
        return thumbnails.findIndex((button) => button.hasAttribute('aria-current'));
      }

      step(direction) {
        const thumbnails = this.visibleThumbnails();
        thumbnails[this.currentIndex(thumbnails) + direction]?.click();
      }

      update() {
        const thumbnails = this.visibleThumbnails();
        const index = this.currentIndex(thumbnails);
        const [prevButton, nextButton] = this.navButtons;

        this.navButtons.forEach((button) => {
          button.hidden = thumbnails.length < 2;
        });
        prevButton.disabled = index <= 0;
        nextButton.disabled = index === -1 || index >= thumbnails.length - 1;
      }
    }
  );
}

if (!customElements.get('akr-name-field')) {
  customElements.define(
    'akr-name-field',
    class AkrNameField extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input');
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.input.addEventListener('input', () => this.update(), { signal });
        this.input.addEventListener('change', () => {
          this.input.value = this.input.value.trim();
          this.update();
        }, { signal });
        // The product form can be re-rendered when the variant changes, so the field is refreshed right before
        // Add to cart and before the Buy it now button acts.
        document.addEventListener('submit', () => this.update(), { capture: true, signal });
        document.addEventListener(
          'click',
          (event) => {
            if (event.target.closest('.shopify-payment-button')) this.update();
          },
          { capture: true, signal }
        );
        this.update();
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      // The name travels in a hidden field inside the product form, which every way of buying reads. An empty box
      // removes it, so the cart line and the order get no blank "Name".
      update() {
        const count = this.querySelector('[data-akr-name-count]');
        if (count) count.textContent = this.input.value.length;
        const form = this.input.form;
        if (!form) return;
        const value = this.input.value.trim();
        let hidden = form.querySelector('input[type="hidden"][data-akr-name]');
        if (!value) {
          hidden?.remove();
          return;
        }
        if (!hidden) {
          hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = this.input.dataset.name;
          hidden.dataset.akrName = '';
          form.append(hidden);
        }
        hidden.value = value;
      }
    }
  );
}
